import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Automotive Design Foundations & Vehicle Anatomy",
    description:
      "Introduction to car design,Role of designers in auto industry, Key components of a vehicle: exterior interior chassis, Automotive design workflow: sketch → concept → prototype → production, Understanding vehicle proportions & aerodynamics, Trends in EVs autonomous vehicles & futuristic cars",
  },
  {
    title: "Sketching, Ideation & Creative Concept Development",
    description:
      "Basics of automotive sketching techniques, Line quality perspective & shading for cars, Generating unique design ideas, Concept development based on brand identity, Rapid visualization & thumbnail sketching",
  },
  {
    title: "Exterior Car Design & Body Styling",
    description:
      "Designing car exteriors: front rear sides silhouette, Headlights bumpers grilles doors & body flow, Surface development & character lines, Understanding proportions for sedans SUVs sports cars, Clay modeling basics (virtual & physical)",
  },
  {
    title: "Interior Car Design & Ergonomics",
    description:
      "Designing dashboards seats consoles displays, Material selection: leather fabric polymers composites, Human-centered design for comfort & accessibility, Seating posture legroom & interior space planning, UI/UX for digital automotive interfaces",
  },
  {
    title: "3D Modeling for Automobile Design (Blender/Autodesk Alias)",
    description:
      "Introduction to automotive 3D modeling software, Creating 3D car surfaces & curves, Solid modeling vs surface modeling, High-poly & low-poly modeling for car prototypes, Exporting models for visualization & simulation",
  },
  {
    title: "CAD Tools, Engineering Drawings & Blueprint Creation",
    description:
      "Understanding engineering drawings & orthographic views, Creating automotive blueprints, Using CAD tools (AutoCAD SolidWorks Fusion 360), Drafting precise car components, Integrating engineering accuracy with design freedom",
  },
  {
    title: "Aerodynamics, Materials & Automotive Engineering Basics",
    description:
      "Basics of aerodynamics & wind resistance, Material selection: steel aluminum carbon fiber, Understanding chassis drivetrain & mechanical layout, Designing for safety performance & fuel efficiency, Integration of electric vehicle components (batteries motors)",
  },
  {
    title: "Rendering, Visualization & Design Presentation",
    description:
      "Photorealistic rendering of car models, Lighting textures & environment setup, Creating presentation boards & design sheets, Color selection & material finishing, Communicating design intent visually",
  },
  {
    title: "Prototyping, Simulation & Virtual Testing",
    description:
      "Creating virtual prototypes for testing, Simulation of crash safety airflow & ergonomics, VR visualization of full car interiors & exteriors, Model revision & design refinement process, Preparing design for manufacturing",
  },
  {
    title: "Capstone Automotive Design Project & Career Launchpad",
    description:
      "Designing a complete car concept (exterior + interior), 2D sketches → 3D modeling → rendering → prototype, Building a professional automotive design portfolio, Resume & LinkedIn optimization, Interview prep for Automotive Designer CAD Designer Transport Designer roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
